<template>
    <div id="app">
        <div v-show="!visible" class="cover"></div>
        <compHeader/>
        <compContent/>
        <div id="AdFooter">
            <compFooter/>
        </div>
        <a class="contact" href="#AdFooter">
            <img src="./img/btn_hezuo@2x.png" alt="pic"/>
        </a>
    </div>
</template>
<script>
import compHeader from './components/compHeader';
import compContent from './components/compContent';
import compFooter from './components/compFooter';

export default {
    name: 'App',
    components: {
        compHeader,
        compContent,
        compFooter,
    },
    data () {
        return {
            visible: false,
        };
    },
    created () {
        this.showPage();
    },
    methods: {
        showPage () {
            loading.hide();
            this.visible = true;
        },
    }
};
</script>
<style lang='scss'>
@import "@/css/common.scss";
  #app {
    position: relative;
  }
  .cover{
    position: absolute;
    left:0;
    top:0;
    background: #fff;
    width:100%;
    height:100%;
    z-index: 100;
  }
  button {
    padding: 0;
    outline: none;
    border: transparent;
  }
  p, ul, li {
    margin: 0;
    padding: 0;
  }
  li {
    list-style: none;
  }
  img{
    width:100%;
    display: inline-block;
    vertical-align: middle;
  }
  *{
    box-sizing: border-box;
  }
  .contact{
    position: fixed;
    top: 150px;
    right: 0;
    width: vws(46px);
    z-index: 100;
  }
  .blankImg{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background: none;
    transition: -webkit-transform .4s ease;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 0;
    filter: alpha(opacity=0);
}


</style>
